
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';
import { Options, Vue } from 'vue-class-component';
import * as ENUM from '@/enum';

@Options({})
export default class userPaymentData extends Vue {

    @Prop() value: OM.UserPaymentData;

    modalitaPagamentos: string[] = ENUM.ModalitaPagamentoUser.GetAll();

}
